module.exports = __webpack_public_path__ + "img/block0Img03.bbcbf24f.png";